import { useCallback, useState } from "react";
import { type PlanReviewFilter, parsePlanReviewFilter } from "@/lib/plan-review-stage";

const STORAGE_KEY = "nos.plans.reviewFilter";

function readStorage(): PlanReviewFilter {
  try {
    return parsePlanReviewFilter(localStorage.getItem(STORAGE_KEY));
  } catch {
    return "all";
  }
}

/** The Plans page's review-stage tile choice, remembered per browser. */
export function usePlanReviewFilter(): [PlanReviewFilter, (next: PlanReviewFilter) => void] {
  const [filter, setFilterState] = useState<PlanReviewFilter>(readStorage);
  const setFilter = useCallback((next: PlanReviewFilter) => {
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch {
      // localStorage unavailable (private mode) — the choice lasts for this visit only.
    }
    setFilterState(next);
  }, []);
  return [filter, setFilter];
}
